import React, { Component } from 'react';
import {Design, NumberCount} from './specilizing/index';

class Specilizing extends Component {
    constructor(props){
        super(props);
        this.state = {
            design : [
                {
                    id: 1,
                    iconbox: 'iconbox-s1 d-sm-flex align-items-center',
                    iconcolor: 'iconbox-icon color1',
                    spanicon: 'fa fa-html5',
                    title: 'HTML',
                    text01: "Excellent knowledge of HTML5",
                    text02: "sematic tags, elements, headings, tables, forms and the DOM and more..."
                },
                {
                    id: 2,
                    iconbox: 'iconbox-s1 d-sm-flex justify-content-lg-center align-items-center mgl-iconbox-s1',
                    iconcolor: 'iconbox-icon color2 color1',
                    spanicon: 'fa fa-css3',
                    title: 'CSS3',
                    text01: "I am a creative and talented web designer",
                    text02: "Very good knowledge of responsive layout, flex-box media queries, browser compatibilty and more..."
                },
                {
                    id: 3,
                    iconbox: 'iconbox-s1 d-sm-flex justify-content-lg-end align-items-center mgr-iconbox-s1',
                    iconcolor: 'iconbox-icon color3',
                    spanicon: 'fab fa-js-square',
                    title: 'JavaScript',
                    text01: "Javascript, React.js & JQuery",
                    text02: "Proficient in building responsive, component-based web applications using React.js, with hands-on experience in hooks, state management, and integrating RESTful APIs for dynamic user experiences."
                },
                {
                    id: 4,
                    iconbox: 'iconbox-s1 d-sm-flex justify-content-lg-end align-items-center mgr-iconbox-s1',
                    iconcolor: 'iconbox-icon color3',
                    spanicon: 'fa fa-hashtag',
                    title: 'C#',
                    text01: "Skilled in object-oriented programming",
                    text02: "C# Developer – Skilled in object-oriented programming and building robust applications using .NET frameworks, with experience in LINQ, asynchronous programming, and integrating APIs for scalable backend solutions."
                },
                {
                    id: 5,
                    iconbox: 'iconbox-s1 d-sm-flex justify-content-lg-end align-items-center mgr-iconbox-s1',
                    iconcolor: 'iconbox-icon color3',
                    spanicon: 'fa fa-database',
                    title: 'SQL, MySQL DynamoDB',
                    text01: "SQL & Database Developer",
                    text02: "Experienced in designing and querying relational and NoSQL databases including SQL Server, MySQL, and DynamoDB"
                },
              
            ]
        }
    }
    render() {
        return (
            <div className="section slide-personal-Intro-third slide-dark bg-white">
                <section className="specilizing-in s1" id="languages">
                    <div className="container">
                        <div className="flat-title">
                            <h2 className="title-section color-d12 animate-element wow delay5 fadeInDown" data-wow-delay="0.5s">I am passionate about</h2>
                        </div>
                        <div className="row position-relative z-index1">
                            {
                                this.state.design.map(data => (
                                    <Design key={data.id} data={data}/>
                                ))
                            }
                            <div className="flat-spacer" data-desktop="0" data-mobile="0" data-smobile="0"></div>
                            <div className="fact">
                                <NumberCount />
                                <div className="btn-contact bg-s1 text-center">
                                    <h4 className="title color-d12">Check up my GitHub</h4>
                                    <a href="https://github.com/sarauras1" className="color-s1 color-d14">https://github.com/sarauras1</a>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div className="featured-post animate-element wow delay5 fadeInRight" data-wow-delay="0.5s">
                        <img src="images/section/09.png" alt="images" />
                    </div>
                </section>
            </div>
        );
    }
}

export default Specilizing;
